import fetch from 'isomorphic-fetch'
import { authHeader, handleResponse } from './helpers'
import { API_URL } from '../../constants/Config'

export const connectorsService = {
  getConnectors,
  setAuth,
  disconnect
}

async function getConnectors(auth_token, product) {
  const url = `${API_URL}/connectors?product=${product}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then(response => handleResponse(response))
    .then(response => response.connectors)
}

async function setAuth(auth_token, connector_name, product, connector_auth) {
  const reset = connector_auth ? 'false' : 'true'
  const url = `${API_URL}/connectors/${connector_name}?reset=${reset}&product=${product}`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(connector_auth ? connector_auth : {}),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function disconnect(auth_token, connector_name, reset_data) {
  reset_data = reset_data || false;
  const url = `${API_URL}/connectors/${connector_name}?reset=${reset_data}`
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then((response) => handleResponse(response))
    .then((response) => response.connectors)

}
